import {FIELD_RULES} from './rules/fields.js';

export {DISABLE_REASONS} from './reasons.js';
export {buildEditabilityContext} from './context.js';
export {FIELD_RULES} from './rules/fields.js';

/**
 * Collects reason codes from rules that match.
 * @param {Array<function(Object): (string|false)>} rules
 * @param {Object} ctx
 * @return {string[]}
 */
function collectReasons(rules, ctx) {
    const reasons = [];
    for (const rule of rules) {
        const reason = rule(ctx);
        if (reason && !reasons.includes(reason)) {
            reasons.push(reason);
        }
    }
    return reasons;
}

/**
 * Reason codes that disable the field, in rule order.
 * @param {string} fieldId
 * @param {Object} ctx Editability context from buildEditabilityContext.
 * @return {string[]}
 */
export function getDisableReasons(fieldId, ctx) {
    const rules = FIELD_RULES[fieldId] || [];
    return collectReasons(rules, ctx);
}

/**
 * True when at least one rule disables the field.
 * @param {string} fieldId
 * @param {Object} ctx
 * @return {boolean}
 */
export function isFieldDisabled(fieldId, ctx) {
    return getDisableReasons(fieldId, ctx).length > 0;
}
